module.exports = __webpack_public_path__ + "img/XL_PERSO_FICHE_INDIVIDU.248b6927.svg";